export const LOCUS_LOOKUP_TABLE = 'locus_lookup_table'
export const LOCUS_LOOKUP_TABLE_COLUMN = 'locus_lookup_table_column'
export const LOCUS_CREATE_NEW_ROW = 'locus_create_new_row'
export const LOCUS_GROUP_LOOKUP_TABLE = 'locus_group_lookup_table'
export const LOCUS_GROUP_LOOKUP_TABLE_COLUMN = 'locus_group_lookup_table_column'
export const LOCUS_GROUP_CREATE_NEW_ROW = 'locus_group_create_new_row'
